import { runExtraction } from "./pipeline/runExtraction";

export { OCR_API_BASE } from "./paddle/paddleTextClient";
export { runExtraction } from "./pipeline/runExtraction";

/** OCR is proxied through the CMS Laravel API (`/api/v1/ocr/*`). */
export const isOcrServiceConfigured = () => true;

/**
 * Run the full OCR pipeline: ingest file → call CMS OCR API → return ExtractionResult.
 * @param {File} file
 * @param {string} [documentType]
 * @param {{ onProgress?: (payload: object) => void }} [options]
 * @returns {Promise<import("./types").ExtractionResult>}
 */
export async function extractDocumentFromFile(file, documentType, options = {}) {
  return runExtraction(file, documentType, options);
}
